export default __webpack_public_path__ + "static/media/seo.57df4111.png";